const popupOpenAndCloseLogic = (popup, backDrop) => {

    if (!popup.classList.contains('open')) {
        //open
        document.body.classList.add('is-scroll-hidden');
        backDrop.classList.add('open');
        setTimeout(() => {
            popup.classList.add('open');
        }, 10);
    }
    else {
        //close
        popup.classList.remove('open');

        setTimeout(() => {
            backDrop.classList.remove('open');
        }, 300);
        document.body.classList.remove('is-scroll-hidden');
    }
}

const assignBackDropClose = (popup, backDrop) => {
    backDrop.addEventListener('click', () => {
        popup.classList.remove('open');


        setTimeout(() => {
            backDrop.classList.remove('open');
        }, 300);
        document.body.classList.remove('is-scroll-hidden');
    })
}

const sortPopup = () => {
    const button = document.querySelector('[data-sort-navigation-button]');
    const popup = document.querySelector('[data-sort-navigation-list]');
    const overlay = document.querySelector('[data-sort-navigation-overlay]');
    const closeButton = document.querySelector('[data-sort-navigation-close]');
    const optionInputs = document.querySelectorAll('[data-sort-navigation-item] input');
    const form = document.getElementById('SortForm');

    button.addEventListener('click', () => {
        popupOpenAndCloseLogic(popup, overlay);
    })

    closeButton.addEventListener('click', () => {
        popupOpenAndCloseLogic(popup, overlay);
    })

    optionInputs.forEach(input => {
        input.addEventListener('change', () => {
            popupOpenAndCloseLogic(popup, overlay);
            setTimeout(() => {
                form.submit();
            }, 300)

        });
    });

    assignBackDropClose(popup, overlay);
}

const disableLink = () => {
    const links = document.querySelectorAll('a.pagination__item.disabled');
    links.forEach(link => {
        link.addEventListener('click', e => e.preventDefault());
    })
}

disableLink();
sortPopup();